const DUCTED_ONLY_AIR_HANDLER_CODES: ReadonlySet<string> = new Set([
  'ducted',
  'evap_coil'
]);

export function isDuctedOnlyAirHandlerCode(
  airHandlerTypeCode: string | null | undefined
): boolean {
  return (
    airHandlerTypeCode != null &&
    DUCTED_ONLY_AIR_HANDLER_CODES.has(airHandlerTypeCode)
  );
}

export function resolveZoneType(params: {
  persistedType?: string | null;
  condenserTypeCode?: string | null;
  airHandlerTypeCode?: string | null;
}): 'ducted' | 'ductless' {
  if (isDuctedOnlyAirHandlerCode(params.airHandlerTypeCode)) {
    return 'ducted';
  }
  if (
    params.persistedType === 'ducted' ||
    params.persistedType === 'ductless'
  ) {
    return params.persistedType;
  }
  if (params.condenserTypeCode === 'ducted') {
    return 'ducted';
  }
  return 'ductless';
}

export function zoneTypeCodeForSave(zone: {
  type: 'ducted' | 'ductless';
  airHandler?: { airHandlerTypeCode?: string | null } | null;
}): 'ducted' | 'ductless' {
  return resolveZoneType({
    persistedType: zone.type,
    airHandlerTypeCode: zone.airHandler?.airHandlerTypeCode
  });
}
